<template>
  <div class="loader" v-if="loading"></div>
  <div class="" style="margin: 0px 60px 0px 80px">
    <div class="page-title-container d-flex w-100">
      <h1 style="white-space: nowrap">Performance Management</h1>
      <div v-if="this.permissions.includes('Performance-Management-Permission')" class="d-flex align-items-center" style="width: 100%">
        <button type="button" class="btn btn-primary create-btn" style="margin-left: auto; background-color: #0056b3" @click="goToCreate">
          <div style="font-weight: 600;">+ Create Form</div>
        </button>
      </div>
    </div>
    <div class="form-tabs mt-2" style="box-shadow: 2px 6px 10px 0px rgb(145, 145, 145);">
      <nav>
        <div class="nav nav-tabs" role="tablist" style="border: 0px solid rgb(122, 122, 122); border-bottom: none; background-color: #d05959;">
          <button 
            v-if="this.permissions.includes('Performance-Management-Permission') || permissions.includes('Final-Review-Permission') || employeeId == 'SG001'"
            class="nav-link" 
            :class="{'active': activeTab == 'All Forms'}" 
            @click="setActiveTab('All Forms')"
          >
            <strong>All Forms</strong>
          </button>
          <button 
            class="nav-link" 
            :class="{'active': activeTab == 'My Forms'}" 
            @click="setActiveTab('My Forms')"
          >
            <strong>My Forms</strong>
          </button>
          <button 
            v-if="this.employees.length != 0"
            class="nav-link" 
            :class="{'active': activeTab == 'Team Forms'}" 
            @click="setActiveTab('Team Forms')"
          >
            <strong>Team Forms</strong>
          </button>
        </div>
      </nav>
      <div class="tab-content" style="border: 1px solid rgb(122, 122, 122); border-top: none; margin-bottom: 20px">

        <!-- All forms -->
        <div 
          v-if="this.permissions.includes('Performance-Management-Permission') || permissions.includes('Final-Review-Permission') || employeeId == 'SG001'"
          class="tab-pane fade" 
          :class="{'show active': activeTab == 'All Forms'}"
        >

        <div class="table-container" style="">
          <table id="all-forms-table" class="row-border" style="width: 100%; font-size: 0.9em;">
            <!-- Table comes here -->
            <tbody></tbody>
          </table>
        </div>

        </div>
        <!-- End of all forms -->

        <!-- My Forms -->
        <div 
          class="tab-pane fade" 
          :class="{'show active': activeTab == 'My Forms'}"
        >

        <div class="table-container" style="">
          <table id="your-forms-table" class="row-border" style="width: 100%; font-size: 0.9em;">
            <!-- Table comes here -->
            <tbody></tbody>
          </table>
        </div>

        </div>
        <!-- End of My Forms -->

        <!-- Team forms -->
        <div
          v-if="this.employees.length != 0"
          class="tab-pane fade" 
          :class="{'show active': activeTab == 'Team Forms'}"
        >

        <div class="table-container" style="">
          <table id="team-forms-table" class="row-border" style="width: 100%; font-size: 0.9em;">
            <!-- Table comes here -->
            <tbody></tbody>
          </table>
        </div>

        </div>
        <!-- End of team forms -->

      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import $ from 'jquery';
import { decryptData } from '../js/utils/encrypt';
import 'datatables.net-dt/css/jquery.dataTables.min.css';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';

export default {
  data() {
    return {
      permissions: '',
      whoami: 'linemanager',
      reportees: [],
      employees:[],
      encryptedEmployeeID: '',
      encryptedEmailID: '',
      employeeId: '',
      loading: false,
      renderedTable: '',
      renderedYourFormsTable: '',
      renderedTeamFormsTable: '',
      activeTab: 'All Forms',
    };
  },

  mounted() {
    //Decrypting Permissions
    
    let mkLocalData = localStorage.getItem('Permissions');
    if (!mkLocalData) {
      mkLocalData = 'null';
    }
    const secretPermissionKey = process.env.KEY || 'myscecretkey';
    this.permissions = decryptData(mkLocalData, secretPermissionKey);

    //Done for Leave Admin and Executive role
    if (this.permissions.includes('Leave-Admin')) {
      this.whoami = 'leaveadmin';
    } else if (this.permissions.includes('Executive')) {
      this.whoami = 'executive';
    }

    if(!this.permissions.includes('Performance-Management-Permission') && !this.permissions.includes('Final-Review-Permission')) {
      this.activeTab = 'My Forms';
    }

    this.encryptedEmployeeID = localStorage.getItem('EmployeeID');
    this.encryptedEmailID = localStorage.getItem('Email');
    const secretKey = process.env.KEY || 'myscecretkey';
    this.employeeId = decryptData(this.encryptedEmployeeID, secretKey).replace(/['"]+/g, '');
    if(this.employeeId == 'SG001') {
      this.activeTab = 'All Forms';
    }
    this.showDatatable();
  },

  methods: {
    async showDatatable() {
      this.loading = true;
      await this.getReporteesData();
      await this.getEmployeeData();
      axios.get(this.$hostName + '/getAllViewQuestionsForEmployee')
      .then(response => {

        let dataForTable = response.data;
        let dataForYourFormsTable = [];
        let dataForTeamFormsTable = [];
        // console.log('dataaaaaaa',response);
        // let formIds = [];
        // for(let each of response.data.questions) {
        //   let key = `${each.form_id}-${each.employee_id}`;
        //   if(!formIds.includes(key)) {
        //     formIds.push(key);
        //     let obj = {};
        //     obj.employee_name = each.employee_name;
        //     obj.employee_id = each.employee_id;
        //     obj.review_start_date = each.review_start_date;
        //     obj.review_end_date = each.review_end_date;
        //     obj.published = each.published;
        //     obj.submitted = each.submitted;
        //     obj.reviewer_submitted = each.reviewer_submitted;
        //     obj.departments = each.department_name;
        //     obj.selectedReviewer = each.reviewer_name;
        //     obj.form_id = each.form_id;
        //     dataForTable.push(obj);
        //   console.log('dataForTable',dataForTable);
        //   }
        // }
      
        dataForYourFormsTable = dataForTable.filter(ele => {
          if(ele.employee_id == this.employeeId && ele.published) return true;
          else return false;
        }).map(record => ({
            ...record,
            selectedReviewer: record.selectedReviewer, // Ensure selectedReviewer is mapped here
        }));
        // console.log('bef: ', this.reportees);
        // console.log('Filtered data for your forms table:', dataForYourFormsTable);
        let formIds = this.employees.teamformdata;
        // this.reportees.forEach((ele => {
        //   reporteesIds.push(ele.empid)
        // }));
      //  console.log('formiddddd',formIds);
        dataForTeamFormsTable = dataForTable.filter(ele => {
          if(formIds.includes(ele.form_id) && ele.published) return true;
          else return false;
        });
      // console.log('dataaaaaaaaa',dataForTeamFormsTable);
        // console.log('reportees: ', this.reportees);
        // console.log('dataForYourFormsTable:', dataForYourFormsTable);
        // console.log('dataForYourTeamsTable:', reporteesIds);

        this.renderedTable = $('#all-forms-table').DataTable({
          responsive: true,
          destroy: true,
          language: {
            searchPlaceholder: 'Enter text to search'
          },
          data: dataForTable,
          columns: [
            { data: 'employee_id', title: 'Employee ID', width: '10%' },
            { data: 'employee_name', title: 'Employee Name' },
            { data: null, title: 'Appraisal Period', render: function(data) {
              let start = new Date(data.review_start_date);
              let end = new Date(data.review_end_date);
              return (`${start.toLocaleDateString()} to ${end.toLocaleDateString()}`);
            }},
            // { data: 'review_end_date', title: 'Review End Date' },
            { data: 'departments', title: 'Department' },
            { 
              data: null, 
              title: 'Published' ,
              render: function(data) {
                if(data.published == true) {
                  return (
                    // 'Published'
                    
                  '<div class="bi bi-check-circle-fill ml-4" style="color: green; font-size: 1.2rem;"></div>'
                  );
                } else {
                  return (
                    ''
                    // '<div class="bi bi-check-circle-fill ml-4" style="color: rgb(212, 212, 21); font-size: 1.2rem;"></div>'
                    // 'Unpublished'
                    );
                }
              }
            },
            {
              data: null,
              title: 'Actions',
              render: function (data, type, row) {
                return (
                  '<button type="button" class="btn btn-primary btn-edit" style="margin-right:10px;" data-id="' +
                  row.employee_id +
                  '" data-name="' +
                  row.employee_name +
                  '" data-departments="' +
                  row.departments +
                  '" data-formid="' +
                  row.form_id +
                  '" data-formtype="' +
                  'All Forms' +
                  '">View</button><button type="button" class="btn btn-primary btn-download" data-id="' +
                  row.employee_id +
                  '" data-name="' +
                  row.employee_name +
                  '" data-departments="' +
                  row.departments +
                  '" data-formid="' +
                  row.form_id +
                  '" data-formtype="' +
                  'All Forms' +
                  '">Download</button>'
                );
              },
            },
          ],
        });

        $('#all-forms-table').on('click', '.btn-edit', (event) => {
          let employee_id = $(event.target).data('id');
          let employee_name = $(event.target).data('name');
          let departments = $(event.target).data('departments');
          let formId = $(event.target).data('formid');
          let formType = $(event.target).data('formtype');

          this.$router.push({
            name: 'editperformancemanagement',
            params: { id: employee_id, name: employee_name, departments: departments, formId: formId, formType: formType },
          });
        });

        $('#all-forms-table').on('click', '.btn-download', (event) => {
          let employee_id = $(event.target).data('id');
          let employee_name = $(event.target).data('name');
          let departments = $(event.target).data('departments');
          let formId = $(event.target).data('formid');

          var formData = {
            empId: employee_id,
            empName: employee_name,
            empDept: departments,
            formId: formId,
            rName: 'Performance Management Review Form',
            rType: 'pm',
            fType: 'pdf',
          };
          this.loading = true;
          axios({
            url: this.$hostName + '/downloadReport',
            method: 'POST',
            responseType: 'blob',
            data: formData,
          })
            .then((response) => {
              const binaryResponse = new Blob([response.data]);
              if (binaryResponse.size > 10) {
                var fileURL = window.URL.createObjectURL(binaryResponse);
                var fileLink = document.createElement('a');
                fileLink.href = fileURL;
                var fileName =
                  employee_id + '_' + employee_name + '_Review_Form.pdf';
                fileLink.setAttribute('download', fileName);
                document.body.appendChild(fileLink);
                fileLink.click();
                fileLink.remove();
              } else {
                Swal.fire({
                  text: 'No data for the selected filter criteria',
                  confirmButtonText: 'Ok',
                });
              }
            })
            .finally(() => {
              this.loading = false;
            });
        });

        this.renderedYourFormsTable = $('#your-forms-table').DataTable({
          responsive: true,
          destroy: true,
          language: {
            searchPlaceholder: 'Enter text to search'
          },
          data: dataForYourFormsTable,
          columns: [
            {
              data: 'employee_id', title: 'Employee ID', width: '10%'
            },
            {
              data: null,
              title: 'Appraisal Period',
              render: function(row) {
                let start = new Date(row.review_start_date);
                let end = new Date(row.review_end_date);
                return (`${start.toLocaleDateString()} to ${end.toLocaleDateString()}`);
              },
            },
            {
              data: null,
              title: 'Submitted',
              render: function(row) {
                if(row.submitted == true) {
                  return (
                  '<div class="bi bi-check-circle-fill ml-4" style="color: green; font-size: 1.2rem;"></div>'
                  );
                } else {
                  return (
                    ''
                    );
                }
              },
            },
            { data: 'selectedReviewer', title: 'Reviewer' },
            {
              data: null,
              title: 'Reviewed',
              render: function(row) {
                if(row.reviewer_submitted == true) {
                  return (
                  '<div class="bi bi-check-circle-fill ml-4" style="color: green; font-size: 1.2rem;"></div>'
                  );
                } else {
                  return (
                    ''
                    );
                }
              },
            },
            {
              data: null,
              title: 'Actions',
              render: function (data, type, row) {
                return (
                  '<button type="button" class="btn btn-primary btn-edit" style="" data-id="' +
                  row.employee_id +
                  '" data-name="' +
                  row.employee_name +
                  '" data-departments="' +
                  row.departments +
                  '" data-formid="' +
                  row.form_id +
                  '" data-formtype="' +
                  'My Forms' +
                  '">View</button>'
                );
              },
            },
          ]
        });

        $('#your-forms-table').on('click', '.btn-edit', (event) => {
          let employee_id = $(event.target).data('id');
          let employee_name = $(event.target).data('name');
          let departments = $(event.target).data('departments');
          let formId = $(event.target).data('formid');
          let formType = $(event.target).data('formtype');

          this.$router.push({
            name: 'editperformancemanagement',
            params: { id: employee_id, name: employee_name, departments: departments, formId: formId, formType: formType },
          });
        });

        this.renderedTeamFormsTable = $('#team-forms-table').DataTable({
          responsive: true,
          destroy: true,
          language: {
            searchPlaceholder: 'Enter text to search'
          },
          data: dataForTeamFormsTable,
          columns: [
            { data: 'employee_id', title: 'Employee ID', width: '10%' },
            { data: 'employee_name', title: 'Employee Name' },
            { data: null, title: 'Appraisal Period', render: function(data) {
              let start = new Date(data.review_start_date);
              let end = new Date(data.review_end_date);
              return (`${start.toLocaleDateString()} to ${end.toLocaleDateString()}`);
            }},
            { 
              data: null, 
              title: 'Submitted' ,
              render: function(data) {
                if(data.submitted == true) {
                  return (
                  '<div class="bi bi-check-circle-fill ml-4" style="color: green; font-size: 1.2rem;"></div>'
                  );
                } else {
                  return (
                    ''
                    );
                }
              }
            },
            {
              data: 'selectedReviewer', // Assuming each record has this property
              title: 'Reviewer',
              render: function(data) {
                return data || ''; // Display the selected reviewer or an empty string if not set
              }
            },
            { 
              data: null, 
              title: 'Reviewed' ,
              render: function(data) {
                if(data.reviewer_submitted == true) {
                  return (
                  '<div class="bi bi-check-circle-fill ml-4" style="color: green; font-size: 1.2rem;"></div>'
                  );
                } else {
                  return (
                    ''
                    );
                }
              }
            },
            {
              data: null,
              title: 'Actions',
              render: function (data, type, row) {
                return (
                  '<button type="button" class="btn btn-primary btn-edit" style="" data-id="' +
                  row.employee_id +
                  '" data-name="' +
                  row.employee_name +
                  '" data-departments="' +
                  row.departments +
                  '" data-formid="' +
                  row.form_id +
                  '" data-formtype="' +
                  'Team Forms' +
                  '">View</button>'
                );
              },
            },
          ]
        });

        $('#team-forms-table').on('click', '.btn-edit', (event) => {
          let employee_id = $(event.target).data('id');
          let employee_name = $(event.target).data('name');
          let departments = $(event.target).data('departments');
          let formId = $(event.target).data('formid');
          let formType = $(event.target).data('formtype');

          this.$router.push({
            name: 'editperformancemanagement',
            params: { id: employee_id, name: employee_name, departments: departments, formId: formId, formType: formType },
          });
        });
        $('#your-forms-table_wrapper .dataTables_length select, #all-forms-table_wrapper .dataTables_length select, #team-forms-table_wrapper .dataTables_length select')
    .css({
        'width': '60px',
        'margin-top': '5px' // Adjust width as needed
    });

      })
      .catch(error => console.error(error))
      .finally(() => this.loading = false);
    },

    async getReporteesData() {
      await axios.post(this.$hostName + '/getManagerDirectReportees', {
        empid: this.employeeId,
        whoami: this.whoami,
      })
      .then(response => {
        // console.log('reportee:', response.data);
        this.reportees = response.data[1].directReportsData;
        // console.log('reports: ', this.reportees);
      });
    },

    async getEmployeeData() {
      // console.log('empid111111111111',this.employeeId);
    await axios.post(this.$hostName + '/getEmployeeData', {
      empid: this.employeeId,
      whoami: this.whoami,
      })
      .then(response => {
      // console.log('empid',this.employeeId);
    this.employees = response.data;
    // console.log('this.employees:', this.employees.teamformdata);
  });
},




    goToCreate() {
      console.log('pressed');
      this.$router.push({ name: 'performancemanagement' });
    },

    setActiveTab(tab) {
      this.activeTab = tab;
    }
  }
};

</script>

<style scoped>
@import "~bootstrap-icons/font/bootstrap-icons.css";

* {
  font-family: Montserrat;
  box-sizing: border-box;
}

.page-title-container {
  margin-top: 20px;
  margin-left: 10px;
}

.create-btn {
  border: none;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 15px;
  padding-right: 15px;
  border-radius: 10px;
}

.create-btn:hover {
  background-color: #003976;
}

.form-tabs {
  margin-left: 10px;
}

.nav-tabs .nav-link {
  border-radius: unset !important;
}

.nav-tabs .nav-link.active {
  background-color: white;
  border: 1px solid rgb(122, 122, 122);
  border-bottom: none;
}

.tab-pane {
  background-color: rgba(212, 212, 212, 0.24);
}

.dataTables_wrapper .dataTables_paginate .paginate_button:hover {
  background: white;
  border: 1px white solid;
}

.dataTables_wrapper .dataTables_length select {
    width: 50px !important;
    display: inline-block;
}

.page-item.active .page-link:hover {
  background-color: #003976;
  border-color: #003976;
}

.table-container {
  /* margin-top: 20px; */
  padding-top: 20px;
  margin-left: 20px;
  margin-right: 20px;
}

</style>